import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { GuserService } from './guser.service';

@Injectable({
  providedIn: 'root'
})
export class PayGuard implements CanActivate {
  
  key:number=0;
  
  constructor(private log:AuthService, private router:Router, private UserService:GuserService){}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Promise<any> {
    return new Promise(
      (resolve,reject) => {
        this.UserService.getCurrentUser().then(user => {
          if(user && this.key==1){
            return resolve(true);
          }
          else{
            this.router.navigate(['']);
            return resolve(false);
          }
        })
      }
    )
  }
}